<template>
    <div class="max-w-[350px] relative pb-5">
        <p class="font-bold" :class="enable ? 'text-black' : 'text-gray-400'">
            {{ title }}
        </p>
        <div class="relative">
            <button
                :disabled="!enable"
                @click.prevent="
                    showSelectParticipants = !showSelectParticipants
                "
                :class="
                    enable
                        ? 'text-black border-gray-500 focus:border-gray-300'
                        : 'text-gray-400 bg-[#CDCDCD]'
                "
                class="
                    transition-all
                    form-select
                    border
                    rounded-2xl
                    w-full
                    text-left
                    max-h-[1150px]
                    mt-1
                    hover:bg-gray-300
                    hover:border-gray-300
                    whitespace-nowrap
                    overflow-x-hidden
                    overflow-ellipsis
                ">
                <input
                    v-if="radioValue"
                    type="radio"
                    id="two"
                    value="Dois"
                    checked
                />
                {{ radioValue ? (radioValue.name || radioValue) : placeholder }}
            </button>
        </div>
        <div v-show="showSelectParticipants">
            <div class="relative">
                <input
                    v-model="searchName"
                    placeholder="Faça sua pesquisa aqui"
                    class="text-black border-gray-500 focus:border-gray-500 transition-all form-select border rounded-2xl w-full text-left max-h-[42px] mt-1"
                />
                <div
                    v-if="enable"
                    class="flex justify-center items-center absolute top-[5px] right-[1px] h-[40px] w-[40px] rounded-2xl bg-gray-200"
                    @click.prevent="
                        showSelectParticipants = !showSelectParticipants
                    "
                >
                    <Icon name="Pesquisar" class="w-[16px]" />
                </div>
            </div>
            <div
                v-if="filteredOptions?.length"
                class="flex flex-col absolute overflow-hidden w-full border border-gray-500 bg-white rounded-2xl mt-2 overflow-y-scroll max-h-[40vh]"
            >
                <label
                    class="flex items-center gap-x-2 p-2 border-t-2 first:border-t-0"
                    v-for="option in filteredOptions"
                    :key="option.id"
                >
                    <input
                        class="min-w-[15px]"
                        type="radio"
                        :value="option"
                        @click="
                            setValue(option);
                            onChange && onChange(option);
                        "
                        v-model="radioValue"
                    />
                    <p>{{ option.name }}</p>
                </label>
            </div>
            <div v-else class="grid my-2">
                <label class="text-center text-lg text-[#808080]">
                    Não encontramos nenhum resultado para o termo digitado
                </label>
            </div>
        </div>
    </div>
</template>
<script>
import Icon from "@/Components/UI/Icons/Icon.vue";

export default {
    components: {
        Icon,
    },
    props: {
        title: String,
        options: Object,
        enable: {
            type: Boolean,
            default: true,
        },
        order: {
            type: Boolean,
            default: true,
        },
        placeholder: String,
        onChange: Object,
        clear: false,
        initialValue: Object,
        modelValue: Object
    },
    data() {
        return {
            searchName: "",
            radioValue: this.initialValue,
            showSelectParticipants: false,
        };
    },
    computed: {
        filteredOptions() {
            return this.orderedOptions.filter(
                (user) =>
                    user?.name
                        .toLowerCase()
                        .indexOf(this.searchName.toLowerCase()) > -1
            );
        },
        orderedOptions() {
            return this.order? this.options.sort((a, b) => (a.name > b.name ? 1 : -1)): this.options;
        },
    },
    watch: {
        clear() {
            if (this.clear) {
                this.radioValue = "";
            }
        },
        initialValue: {
            handler(newValue) {
                this.radioValue = newValue;
            },
        },
        modelValue(newValue) {
            if(newValue != this.radioValue) {
                this.radioValue = newValue;
            }
        }
    },
    methods: {
        setValue(value) {
            this.showSelectParticipants = false;
            this.$emit("updateValue", value);
        },
    },
};
</script>
<style scoped>
/* Hide scrollbar for Chrome, Safari and Opera */
/* .no-scroll-bar::-webkit-scrollbar {
    display: none;
} */

/* Hide scrollbar for IE, Edge and Firefox */
/* .no-scroll-bar {
    -ms-overflow-style: none;
    scrollbar-width: none;
} */
</style>
